import React, { useState } from "react";

const ContactThree = () => {
  const [status, setStatus] = useState("");
  const [loading, setLoading] = useState(false);

  const encode = (data) => {
    return Object.keys(data)
      .map(
        (key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key])
      )
      .join("&");
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const form = e.target;
    const formData = {
      "form-name": "contact",
      name: form.name.value,
      email: form.email.value,
      tel: form.tel.value,
      content: form.content.value,
    };

    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: encode(formData),
    })
      .then(() => {
        setStatus("success");
        setLoading(false);
        form.reset();
      })
      .catch(() => {
        setStatus("error");
        setLoading(false);
      });
  };

  return (
    <section className="contact_form_area contact_us section_padding">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="contact-right contact_details">
              <div className="hero-title-with-shape">
                <h4 className="heading_with_border">Kontaktirajte nas</h4>
                <h1>Nudimo 24/7 podršku svim našim klijentima</h1>
              </div>
              <div className="contact_location_box">
                <div className="contact_location_map">
                  <span className="icon-location"></span>
                  <p>
                    Bulevar JNA 22, <br />
                    Beograd
                  </p>
                </div>
                <div className="contact_location_map contact_location_call">
                  <span className="icon-contact_call"></span>
                  <p>
                    klimaservisvv@gmail.com <br />
                    065/44 88 222
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="contact-right contact-right-style-2 responsive_mt">
              <form
                name="contact"
                method="POST"
                data-netlify="true"
                data-netlify-honeypot="bot-field"
                onSubmit={handleSubmit}
              >
                <input type="hidden" name="form-name" value="contact" />
                <p hidden>
                  <label>
                    Don't fill this out: <input name="bot-field" />
                  </label>
                </p>

                <input
                  className="half_width input_m_right"
                  type="text"
                  name="name"
                  placeholder="Vaše ime"
                  required
                />
                <input
                  className="half_width"
                  type="email"
                  name="email"
                  placeholder="Email adresa"
                  required
                />
                <input
                  type="tel"
                  name="tel"
                  placeholder="Broj telefona"
                  required
                />
                <textarea
                  name="content"
                  cols="20"
                  rows="5"
                  placeholder="Napišite poruku"
                  required
                ></textarea>
                <button className="btn-yellow" type="submit" disabled={loading}>
                  {loading ? "ŠALJE SE..." : "POŠALJITE"}
                </button>

                {status === "success" && (
                  <p style={{ color: "green", marginTop: "10px" }}>
                    ✓ Poruka je uspešno poslata!
                  </p>
                )}
                {status === "error" && (
                  <p style={{ color: "red", marginTop: "10px" }}>
                    ✗ Došlo je do greške. Pokušajte ponovo.
                  </p>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactThree;
